<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <list-customer
        @editCustomer="editCustomer"
        @addCustomer="addCustomer"
        v-show="isShowList"
      ></list-customer>
      <customer-detail
        :listUser="listUser"
        :isAddCustomer="isAddCustomer"
        :customerSelected="customerSelected"
        @close="close"
        v-if="!isShowList"
      ></customer-detail>
    </div>
  </div>
</template>
<script>
import firebase from "@/services/firebase-init.js";
export default {
  components: {
    ListCustomer: () => import("./ListCustomer"),
    CustomerDetail: () => import("./CustomerDetail"),
  },
  created() {
    this.db = firebase.firestore();
    this.getUser();
  },
  data() {
    return {
      isAddCustomer: false,
      db: {},
      customerSelected: {},
      isShowList: true,
      listUser: [],
    };
  },
  methods: {
    getUser() {
      this.$store.dispatch("FLAG_LOADING", true);
      let bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_USER + bits)
        .get()
        .then((doc) => {
          doc.forEach((item) => {
            this.listUser.push({
              id: item.id,
              data: item.data(),
            });
          });
          this.$store.dispatch("FLAG_LOADING", false);
        })
        .catch((error) => {
          this.$store.dispatch("FLAG_LOADING", false);
          console.log(error);
        });
    },
    editCustomer(item) {
      this.customerSelected = item;
      this.isAddCustomer = false;
      this.isShowList = false;
    },
    addCustomer() {
      this.isAddCustomer = true;
      this.isShowList = false;
    },
    close() {
      this.isAddCustomer = false;
      this.isShowList = true;
      this.customerSelected = {};
    },
  },
};
</script>
<style lang="scss" scoped>
.button-add {
  float: right;
}
</style>
